// extracted by mini-css-extract-plugin
module.exports = {"App__container--brand":"App_App__container--brand__38adP"};